import React from 'react'
import moment from 'moment'
import styled from 'react-emotion'
import {
  fontWeight,
  shadow,
  color,
  Container,
  spacer,
  typography,
  Button
} from 'stylist'

const SessionsContainer = styled(Container)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: ${spacer(5)};
`

const SessionContainer = styled.div`
  background-color: ${color('white')};
  ${shadow('raised')};
`

const SessionTitle = styled.div`
  ${fontWeight('bold')};
`

const SessionDate = styled.div`
  ${typography('body1')};
`

const SessionFacility = styled.div`
  ${typography('body1')};
`

const LiveSessionsContainer = styled.div``

const UpcomingSessionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const LiveSessionBackground = styled.div``

const LiveSessionContents = styled.div`
  padding: ${spacer(5)};
  ${SessionFacility} {
    margin-top: ${spacer(5)};
  }
`

const PlayIcon = styled.div`
  height: calc(${spacer(5)} * 2 + 16px);
  background-color: ${color('forest')};
`

const UpcomingSessionContainer = styled(SessionContainer)`
  display: grid;
  grid-template-columns: 1fr 2fr;
  height: calc(${spacer(5)} * 2 + 16px);
  margin-bottom: ${spacer(2)};

  ${SessionDate} {
    background-color: ${color('purple')};
    color: white;
    ${fontWeight('bold')};
  }

  > div {
    padding: ${spacer(2)} ${spacer(3)};
  }
`

const ScheduleSessionButton = styled(Button)`
  width: 100%;
  align-self: flex-end;
  margin: auto auto 0 auto;
`

const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacer(3)};
`

const LiveSessionTile = ({ date, facilityLocation, facilityName, title }) => (
  <SessionContainer>
    <LiveSessionBackground>
      <PlayIcon />
      <LiveSessionContents>
        <SessionTitle>{title}</SessionTitle>
        <SessionDate>{date}</SessionDate>
        <SessionFacility>
          <div>{facilityName}</div>
          <div>{facilityLocation}</div>
        </SessionFacility>
      </LiveSessionContents>
    </LiveSessionBackground>
  </SessionContainer>
)

const UpcomingSessionTile = ({
  date,
  facilityName,
  facilityLocation,
  title
}) => (
  <UpcomingSessionContainer>
    <SessionDate>{date}</SessionDate>
    <div>
      <SessionTitle>{title}</SessionTitle>
      <SessionFacility>
        <div>{facilityName}</div>
        <div>{facilityLocation}</div>
      </SessionFacility>
    </div>
  </UpcomingSessionContainer>
)

const DashboardSession = () => (
  <SessionsContainer>
    <LiveSessionsContainer>
      <HeadingContainer>
        <h5>LiveSessions</h5>
      </HeadingContainer>
      <LiveSessionTile
        date={moment()
          .hour(9)
          .minute(30)
          .format('MMMM D, h:mm A')}
        facilityLocation="Stamford, CT USA 06902"
        facilityName="Facility Name"
        title="Currently Live Session"
      />
    </LiveSessionsContainer>
    <UpcomingSessionsContainer>
      <HeadingContainer>
        <h5>Upcoming</h5>
      </HeadingContainer>

      <UpcomingSessionTile
        date={moment()
          .add(1, 'days')
          .hour(10)
          .minute(0)
          .format('MMMM D h:mm A')}
        facilityLocation="Stamford, CT USA 06902"
        facilityName="Facility Name"
        title="Upcoming Session"
      />
      <UpcomingSessionTile
        date={moment()
          .add(2, 'days')
          .hour(9)
          .minute(30)
          .format('MMMM D h:mm A')}
        facilityLocation="Stamford, CT USA 06902"
        facilityName="Facility Name"
        title="Another Upcoming Session"
        isUpcoming
      />
      <ScheduleSessionButton kind="standard">
        Schedule a Session
      </ScheduleSessionButton>
    </UpcomingSessionsContainer>
  </SessionsContainer>
)

export default DashboardSession



// WEBPACK FOOTER //
// ./src/routes/videos/components/DashboardSession.js